import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { LogOut, User2, Images, ClipboardList } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { COMPANY } from "@/constants/company";
import { Button } from "@/components/ui/button";

export default function Navbar() {
    const { user, logout } = useAuth();
    const nav = useNavigate();
    return (
        <header className="sticky top-0 z-40 backdrop-blur-xl bg-daylight/85 border-b border-plum/5" data-testid="site-navbar">
            <div className="max-w-6xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between gap-2">
                <Link to="/" className="flex items-center gap-2 group" data-testid="brand-link">
                    {/* Signed in, the nav carries five controls; on a 375px screen
                        Terry alone still identifies us, so the wordmark gives way. */}
                    <img
                        src="/terry/terry-head-wave.png"
                        alt=""
                        aria-hidden
                        draggable={false}
                        className="h-10 sm:h-[46px] w-auto max-w-none shrink-0 anim-terry-wave
                                   drop-shadow-[0_6px_12px_rgba(217,72,111,0.28)]"
                    />
                    <img
                        src="/terry/wordmark.png"
                        alt={COMPANY.name}
                        draggable={false}
                        className={`h-7 sm:h-[34px] w-auto max-w-none ${user ? "hidden sm:block" : "block"}`}
                    />
                </Link>
                <nav className="flex items-center gap-0.5 sm:gap-2 shrink-0">
                    <Link to="/samples">
                        <Button variant="ghost" size="sm" className="rounded-full text-plum" data-testid="nav-samples-btn">
                            <Images className="w-4 h-4 sm:mr-1" /> <span className="hidden sm:inline">Samples</span>
                        </Button>
                    </Link>
                    {user ? (
                        <>
                            {user.role === "admin" && (
                                <Link to="/admin">
                                    <Button variant="ghost" size="sm" className="rounded-full text-plum" data-testid="nav-admin-btn">
                                        <ClipboardList className="w-4 h-4 sm:mr-1" /> <span className="hidden sm:inline">Studio</span>
                                    </Button>
                                </Link>
                            )}
                            <Link to="/library">
                                <Button variant="ghost" size="sm" className="rounded-full text-plum" data-testid="nav-library-btn">
                                    <User2 className="w-4 h-4 sm:mr-1" /> <span className="hidden sm:inline">My Library</span>
                                </Button>
                            </Link>
                            <Link to="/create">
                                <button className="btn-sticker text-xs sm:text-sm whitespace-nowrap" data-testid="nav-create-btn">
                                    ✨ <span className="hidden sm:inline">Create a Story</span><span className="sm:hidden">Create</span>
                                </button>
                            </Link>
                            <Button variant="ghost" size="sm" onClick={async () => { await logout(); nav("/"); }}
                                data-testid="nav-logout-btn" className="rounded-full">
                                <LogOut className="w-4 h-4" />
                            </Button>
                        </>
                    ) : (
                        <>
                            <Link to="/auth"><Button variant="ghost" size="sm" className="rounded-full" data-testid="nav-login-btn">Sign in</Button></Link>
                            <Link to="/auth?mode=signup">
                                <button className="btn-sticker text-xs sm:text-sm whitespace-nowrap" data-testid="nav-signup-btn">
                                    ✨ <span className="hidden sm:inline">Start the magic</span><span className="sm:hidden">Start</span>
                                </button>
                            </Link>
                        </>
                    )}
                </nav>
            </div>
        </header>
    );
}
